var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",function(){return [_c('v-btn',{on:{"click":_vm.gimmick}},[_vm._v("상금")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }